import React__default from 'react';
import { C as ChannelProvider } from './chunks/bundle-e3Ti36sK.js';
import ChannelUI from './Channel/components/ChannelUI.js';
import './chunks/bundle-_iM6nCNy.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-FpyOg33P.js';
import './chunks/bundle-MbdTAPd0.js';
import './chunks/bundle-FKPPxTH5.js';
import './chunks/bundle-beh08z4N.js';
import './chunks/bundle-oJDE4gxT.js';
import './chunks/bundle-HBHAJNcI.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-nfdZFsK-.js';
import '@sendbird/chat/message';
import './chunks/bundle-Qobh-hS4.js';
import './chunks/bundle-tIZkKr0f.js';
import '@sendbird/chat/groupChannel';
import './chunks/bundle--bKgEN9C.js';
import './Channel/hooks/useInitialMessagesFetch.js';
import './chunks/bundle-PjrYdsK-.js';
import './chunks/bundle-wxDl4Uqr.js';
import './chunks/bundle-BQL-EsqQ.js';
import './chunks/bundle-KYdFoSY3.js';
import './ui/PlaceHolder.js';
import './chunks/bundle-qXzcabru.js';
import './chunks/bundle-Qz8Xvs0V.js';
import './ui/Icon.js';
import './chunks/bundle-ZdB7DVTk.js';
import './chunks/bundle-afcKlUXe.js';
import './ui/Loader.js';
import './ui/ConnectionStatus.js';
import './Channel/components/ChannelHeader.js';
import './chunks/bundle-7R8HEAQg.js';
import './ui/IconButton.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-c_C-QxZX.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-M5pt2U9r.js';
import './chunks/bundle-MwrVjf8I.js';
import './chunks/bundle-PS5DHcTM.js';
import './chunks/bundle-JP-jgzbg.js';
import './Channel/components/Message.js';
import './Channel/components/SuggestedMentionList.js';
import './chunks/bundle-qvWKHgxb.js';
import './Thread/context.js';
import './Thread/context/types.js';
import '@sendbird/chat';
import './ui/DateSeparator.js';
import './chunks/bundle-o5Vs-nxR.js';
import './ui/MessageInput.js';
import './ui/Button.js';
import './chunks/bundle-Os1fWxhI.js';
import 'dompurify';
import './chunks/bundle-1g6DWJD0.js';
import './chunks/bundle-_ZNty2ba.js';
import './chunks/bundle-oo5v2vDN.js';
import './chunks/bundle-Ey_7-wSi.js';
import './ui/MessageContent.js';
import './chunks/bundle-TEnd9cUe.js';
import './chunks/bundle-bt0zGtez.js';
import './chunks/bundle-DxDwP2lI.js';
import './ui/MessageItemMenu.js';
import './ui/ContextMenu.js';
import 'react-dom';
import './ui/SortByRow.js';
import './chunks/bundle-un0fMvD_.js';
import './ui/MessageItemReactionMenu.js';
import './ui/ReactionButton.js';
import './chunks/bundle-RsvOCwtb.js';
import './ui/EmojiReactions.js';
import './ui/ReactionBadge.js';
import './ui/BottomSheet.js';
import './hooks/useModal.js';
import './chunks/bundle-tZpfBaVT.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './Message/context.js';
import './ui/AdminMessage.js';
import './ui/QuoteMessage.js';
import './chunks/bundle-mNQe1dzf.js';
import './chunks/bundle-PFX2Yr9t.js';
import './ui/ThreadReplies.js';
import './ui/OGMessageItemBody.js';
import './chunks/bundle-VRFfBFLq.js';
import './ui/MentionLabel.js';
import './ui/LinkLabel.js';
import './ui/TextMessageItemBody.js';
import './ui/FileMessageItemBody.js';
import './ui/TextButton.js';
import './chunks/bundle-vRivVL8u.js';
import './chunks/bundle-mHHG9KoF.js';
import './ui/VoiceMessageItemBody.js';
import './ui/ProgressBar.js';
import './VoicePlayer/useVoicePlayer.js';
import './chunks/bundle-TcioQEN5.js';
import './VoiceRecorder/context.js';
import './ui/PlaybackTime.js';
import './ui/ThumbnailMessageItemBody.js';
import './ui/UnknownMessageItemBody.js';
import './Channel/components/FileViewer.js';
import './Channel/components/RemoveMessageModal.js';
import './chunks/bundle-DzuA_apO.js';
import './Message/hooks/useDirtyGetMentions.js';
import './Channel/utils/getMessagePartsInfo.js';
import './Channel/utils/compareMessagesForGrouping.js';
import './Channel/components/UnreadCount.js';
import './Channel/components/FrozenNotification.js';
import './chunks/bundle-qfjnmlHx.js';
import '@sendbird/uikit-tools';
import './ui/TypingIndicatorBubble.js';
import './Channel/components/TypingIndicator.js';
import './Channel/components/MessageInput.js';
import './ui/QuoteMessageInput.js';
import './chunks/bundle-ynu0QV4r.js';
import './VoiceRecorder/useVoiceRecorder.js';
import './chunks/bundle-78frOEM6.js';
import './Channel/hooks/useHandleUploadFiles.js';
import './chunks/bundle-GPxxY-H1.js';

var Channel = function (props) {
    return (React__default.createElement(ChannelProvider, { channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl, isReactionEnabled: props === null || props === void 0 ? void 0 : props.isReactionEnabled, isMessageGroupingEnabled: props === null || props === void 0 ? void 0 : props.isMessageGroupingEnabled, isMultipleFilesMessageEnabled: props === null || props === void 0 ? void 0 : props.isMultipleFilesMessageEnabled, showSearchIcon: props === null || props === void 0 ? void 0 : props.showSearchIcon, animatedMessage: props === null || props === void 0 ? void 0 : props.animatedMessage, highlightedMessage: props === null || props === void 0 ? void 0 : props.highlightedMessage, startingPoint: props === null || props === void 0 ? void 0 : props.startingPoint, onBeforeSendUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendUserMessage, onBeforeSendFileMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendFileMessage, onBeforeUpdateUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeUpdateUserMessage, onBeforeSendVoiceMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendVoiceMessage, onBeforeSendMultipleFilesMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendMultipleFilesMessage, onChatHeaderActionClick: props === null || props === void 0 ? void 0 : props.onChatHeaderActionClick, onSearchClick: props === null || props === void 0 ? void 0 : props.onSearchClick, onBackClick: props === null || props === void 0 ? void 0 : props.onBackClick, replyType: props === null || props === void 0 ? void 0 : props.replyType, threadReplySelectType: props === null || props === void 0 ? void 0 : props.threadReplySelectType, queries: props === null || props === void 0 ? void 0 : props.queries, renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile, filterMessageList: props === null || props === void 0 ? void 0 : props.filterMessageList, disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile, disableMarkAsRead: props === null || props === void 0 ? void 0 : props.disableMarkAsRead, onReplyInThread: props === null || props === void 0 ? void 0 : props.onReplyInThread, onQuoteMessageClick: props === null || props === void 0 ? void 0 : props.onQuoteMessageClick, onMessageAnimated: props === null || props === void 0 ? void 0 : props.onMessageAnimated, onMessageHighlighted: props === null || props === void 0 ? void 0 : props.onMessageHighlighted, scrollBehavior: props.scrollBehavior, reconnectOnIdle: props.reconnectOnIdle },
        React__default.createElement(ChannelUI, { isLoading: props === null || props === void 0 ? void 0 : props.isLoading, renderPlaceholderLoader: props === null || props === void 0 ? void 0 : props.renderPlaceholderLoader, renderPlaceholderInvalid: props === null || props === void 0 ? void 0 : props.renderPlaceholderInvalid, renderPlaceholderEmpty: props === null || props === void 0 ? void 0 : props.renderPlaceholderEmpty, renderChannelHeader: props === null || props === void 0 ? void 0 : props.renderChannelHeader, renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage, renderMessageInput: props === null || props === void 0 ? void 0 : props.renderMessageInput, renderTypingIndicator: props === null || props === void 0 ? void 0 : props.renderTypingIndicator, renderCustomSeparator: props === null || props === void 0 ? void 0 : props.renderCustomSeparator, renderFileUploadIcon: props === null || props === void 0 ? void 0 : props.renderFileUploadIcon, renderVoiceMessageIcon: props === null || props === void 0 ? void 0 : props.renderVoiceMessageIcon, renderSendMessageIcon: props === null || props === void 0 ? void 0 : props.renderSendMessageIcon, renderFrozenNotification: props === null || props === void 0 ? void 0 : props.renderFrozenNotification })));
};

export { Channel as default };
//# sourceMappingURL=Channel.js.map
